import TwoLineCards from './TwoLineCards';

export default { twoLineCards: TwoLineCards };
